var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.838 7.1535V5.966C13.838 3.401 13.2855 0 8.5 0C3.7145 0 3.162 3.401 3.162 5.966V7.1535C0.782 7.486 0 8.835 0 12.1505V13.9175C0 17.8125 1.0625 19 4.5475 19H12.4525C15.9375 19 17 17.8125 17 13.9175V12.1505C17 8.835 16.218 7.486 13.838 7.1535ZM8.5 15.903C7.0805 15.903 5.933 14.611 5.933 13.034C5.933 11.4475 7.089 10.165 8.5 10.165C9.911 10.165 11.067 11.457 11.067 13.034C11.067 14.6205 9.9195 15.903 8.5 15.903ZM4.5475 7.068C4.4795 7.068 4.42 7.068 4.352 7.068V5.966C4.352 3.1825 5.0575 1.33 8.5 1.33C11.9425 1.33 12.648 3.1825 12.648 5.966V7.0775C12.58 7.0775 12.5205 7.0775 12.4525 7.0775H4.5475V7.068Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLokIcon);
export default __webpack_public_path__ + "static/media/LokIcon.184c2fd4a9afea8a8597954dbc7291f4.svg";
export { ForwardRef as ReactComponent };